<template>
  <component v-for="item in Object.keys(modal)"
             :ref="item" :is="modal[item]" />
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import Modal from '@controller/modal';

export default {
  name: 'sso_modal',
  data(): DataInterface {
    return {
      modal: Modal
    };
  },
  mounted(): void {
    $Store.SSO().updateModal(this.$refs);
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';
</style>